<template>
  <nav aria-label="Główna nawigacja użytkownika">
    <Menubar :model="menuItems" class="app-main-menu">
      <!-- Niestandardowe elementy menu -->
      <template #item="{ item, props, hasSubmenu, root }">
        <a
          class="flex items-center"
          v-bind="props.action"
          :aria-label="item.ariaLabel || item.label"
          :title="item.description"
        >
          <i v-if="item.icon" :class="item.icon" class="mr-2"></i>
          <span>{{ item.label }}</span>
          <i
            v-if="hasSubmenu"
            :class="[
              'pi pi-angle-down ml-auto',
              { 'pi-angle-down': root, 'pi-angle-right': !root },
            ]"
          ></i>
        </a>
      </template>

      <!-- Profil, Wyloguj i Wstecz w sekcji end -->
      <template #end>
        <div class="app-main-menu__actions flex items-center gap-2">
          <Button
            label="Wstecz"
            icon="pi pi-arrow-left"
            class="p-button-text"
            @click="goBack"
            aria-label="Wróć o jedną stronę"
            title="Wróć do poprzednio oglądanej strony"
          ></Button>
          <Button
            label="Profil"
            icon="pi pi-user"
            class="p-button-text"
            @click="navigateTo('Profile')"
            aria-label="Otwórz profil"
          ></Button>
          <Button
            label="Wyloguj"
            icon="pi pi-sign-out"
            class="p-button-text"
            @click="handleLogout"
            aria-label="Wyloguj się"
          ></Button>
        </div>
      </template>
    </Menubar>
  </nav>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { logout } from "@/utils/auth"; // Import metody logout z utils
import { showToast } from "@/utils/toastService";
export default {
  name: "Menu",

  setup() {
    const router = useRouter();

    const navigateTo = (routeName) => {
      router.push({ name: routeName });
    };

    const goBack = () => {
      router.back();
    };

    const handleLogout = async () => {
      try {
        await logout(router); // Wywołanie funkcji logout
      } catch (error) {
        showToast({
          severity: "error",
          summary: "Błąd",
          detail: error.response?.data?.message || "Nie udało się wylogować.",
          life: 3000,
        });
      }
    };

    // Pozycje w menu głównym
    const menuItems = ref([
      {
        label: "Strona główna",
        ariaLabel: "Przejdź do strony głównej",
        description: "Przejdź do początku aplikacji",
        icon: "pi pi-home",
        command: () => navigateTo("Home"),
      },
      {
        label: "Mój Panel",
        icon: "pi pi-sliders-h",
        command: () => navigateTo("PanelUzytkownika"),
      },
      {
        label: "Zadania",
        icon: "pi pi-sliders-h",
        command: () => navigateTo("BrygadzistaAktywneTaski"),
      },
    ]);

    return {
      menuItems,
      navigateTo,
      goBack,
      handleLogout,
    };
  },
};
</script>

<style scoped lang="scss" src="./_main-menu.scss"></style>
